module.exports = __webpack_public_path__ + "static/img/12.51f9e4ed.jpg";